export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";